import { Injectable } from '@angular/core';
import { UiHelperService } from '@core/services/core/ui-helper.service';
import { PolicySinister } from '@models/policy';
import { SinisterAutoType } from '@models/sinister-auto';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class PolicyVehicleAccidentsHelperService {

  constructor(
    private ui: UiHelperService,
    private trans: TranslateService,
  ) {}

  checkSinisterIsValidForRepair(sinister: PolicySinister) {
    if (!sinister) {
      return false;
    }
    const statusIsPending = sinister.status === 'Pendiente';
    const typeIsWithoutContrary =
      sinister.sinisterType === SinisterAutoType.WITH_CONTRARY ||
      sinister.sinisterType === SinisterAutoType.WITHOUT_CONTRARY ||
      sinister.sinisterType === SinisterAutoType.WITHOUT_CONTRARY_LEND;
    return (
      statusIsPending &&
      typeIsWithoutContrary &&
      sinister.expertiseAllowed &&
      !sinister.hasExpertiseAvailable &&
      !sinister.hasWorkshopAvailable &&
      !sinister.hasServiceCenter &&
      !sinister.hasDoorToDoor &&
      !sinister.disappearedVehicle
    );
  }

  showAlertError() {
    this.ui.presentOneButtonCustomAlert(
      this.trans.instant('CAR_SINISTER_REPAIR.ALERT_ERROR.TEXT'),
      this.trans.instant('CAR_SINISTER_REPAIR.ALERT_ERROR.TITLE'),
      'assets/images/car-sinister-without-contrary/ilust-error.svg',
      () => {},
      this.trans.instant('CLOSE')
    );
  }

  filterVehicleAccidentsByType(accidentsList: PolicySinister[], type: SinisterAutoType) {
    return (accidentsList || []).filter(accident => this.checkVehicleAccidentIsOfType(accident, type));
  }

  excludeVehicleAccidentsByType(accidentsList: PolicySinister[], type: SinisterAutoType) {
    return (accidentsList || []).filter(accident => !this.checkVehicleAccidentIsOfType(accident, type));
  }

  checkVehicleAccidentIsOfType(vehicleAccident: PolicySinister, type: SinisterAutoType) {
    return vehicleAccident?.sinisterType === type;
  }

  groupVehicleAccidentsByTypeAtStart(accidentsList: PolicySinister[], type: SinisterAutoType) {
    const vehicleAccidentsList = accidentsList || [];
    vehicleAccidentsList.sort(
      (a, b) => ((a.sinisterType !== type) > (b.sinisterType !== type)) ? 1 : -1
    );
    return vehicleAccidentsList;
  }
}
